import { RunSetupRequest, RunSetupResponse, ClearDataRequest, ClearDataResponse } from "common247";
import { FirebaseServices } from "./config";
import { callFunction } from "./helpers";

export async function runSetup(fb: FirebaseServices): Promise<RunSetupResponse> {
  const result = await callFunction<RunSetupRequest, RunSetupResponse>(fb, "runSetupFunc", {});
  return result;
}

export async function clearEmulatorData(fb: FirebaseServices): Promise<ClearDataResponse> {
  const result = await callFunction<ClearDataRequest, ClearDataResponse>(fb, "clearEmulatorDataFunc", {});
  return result;
}
